import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgFormCheckPlus = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M12 2a10.002 10.002 0 0 1 5.868 1.902L16.44 5.346a8 8 0 0 0-10.096.997A8.002 8.002 0 0 0 12 20c.167 0 .334-.007.5-.018v2.003A10 10 0 1 1 12 2Z"
    />
    <path
      fill="#88827E"
      d="m20.707 6.707-3 3 .003.003-6.71 6.7-4.21-4.2 1.42-1.42 2.79 2.8 2.393-2.398.014.015 5.9-5.9 1.4 1.4ZM20 15v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"
    />
  </svg>
);
export default SvgFormCheckPlus;
